import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AutocompleteComponent,AutocompleteLibModule } from 'angular-ng-autocomplete';

@Component({
  selector: 'lcms-select-filter',
  standalone: true,
  imports: [CommonModule,AutocompleteLibModule,TranslateModule],
  templateUrl: './select-filter.component.html',
  styleUrls: ['./select-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectFilterComponent {
  @Input() items = [];
  @Input() title = '';
  @Input() disabled = false;
  @Input() isLoading = false;
  @Input() clear = true;
  @Input() initialVal = '';
  @Output() selectedItemsChange = new EventEmitter<any[]>();
  selectedItems: any[] = [];
  searchItem = 'label';
  @ViewChild('autocomplete') autocomplete:AutocompleteComponent;
  @Output() SearchItem: EventEmitter<string> = new EventEmitter();
  @Output() ScrollToEnd: EventEmitter<number> = new EventEmitter();

  onChangeSearch(val: string) {
    this.SearchItem.next(val)
  }
  removeElement(arrayData: any[],elem:any, index: any): void {
    arrayData.splice(index, 1);
  }

  selectedValueRenderFn(value: any) {
    // Customize the display of the selected item(s) here
    return value ? value.name : '';
  }

  searchCleared() {
    this.initialVal = ''
    this.SearchItem.next('')
  }
  scrollToEnd(){
    this.ScrollToEnd.next(1)
  }
  onItemChange(item: any) {
    if (item != null && typeof item != 'string') {
     if(this.clear) this.autocomplete.clear();
      this.selectedItemsChange.emit(item);
    }
  }
}
